(function ($) {
    function debounce(func, timeout = 200) {
        let timer;
        return (...args) => {
            clearTimeout(timer);
            timer = setTimeout(() => {
                func.apply(this, args);
            }, timeout);
        };
    }

    (function ($) {
        var $collectionSearchResults = $(".bloomable-search__results.collections");
        var $productSearchResults = $(".bloomable-search__results.products");
        var dashboardUrl = $('meta[name="dashboard_url"]').attr("content");

        $.fn.searchReults = function () {
            var $this = $(this);
            var query = $this.data("terms");

            $this.empty();

            if (query) {
                $.get(dashboardUrl + "/public/search-locations?q=" + query, function (data) {
                    for (let i = 0; i < data.collections.length && i < 5; i++) {
                        if (data.collections[i].handle !== "upsells") {
                            let link = $("<a>")
                                .attr("href", "/collections/" + data.collections[i].handle)
                                .html(data.collections[i].name);

                            $("<li>").append(link).appendTo($this);
                        }
                    }

                    for (let i = 0; i < data.locations.length && i < 5; i++) {
                        let link = $("<a>")
                            .attr("href", "/collections/" + data.locations[i].handle)
                            .html(data.locations[i].name);

                        $("<li>").append(link).appendTo($this);
                    }
                });
            }
        };

        $.fn.search = function () {
            const $this = $(this);
            const $parent = $this.closest("form");

            if ($this.val()) {
                $parent.on("submit", function (event) {
                    event.preventDefault();
                    $.get(dashboardUrl + "/public/search-locations?q=" + $this.val(), function (data) {
                        if (data.location) {
                            location.href = "/collections/" + data.location;
                        } else {
                            event.target.submit();
                        }
                    });

                    return false;
                });
            }
            this.on("focus", function (event) {
                var query = event.target.value;
                if (query.length > 0) {
                    $(".bloomable-search__popup").css("visibility", "visible");
                }
            });
            this.on("blur", function () {
                setTimeout(function () {
                    $(".bloomable-search__popup").css("visibility", "hidden");
                }, 200);
            });
            this.on(
                "keydown",
                debounce(function (event) {
                    var query = event.target.value;

                    if (event.key == "Escape") {
                        $productSearchResults.empty();
                        $collectionSearchResults.empty();
                        setTimeout(function () {
                            $(".bloomable-search__popup").css("visibility", "hidden");
                        }, 200);
                        this.blur();
                    } else if (event.key == "Enter") {
                        $productSearchResults.empty();
                        $collectionSearchResults.empty();
                        setTimeout(function () {
                            $(".bloomable-search__popup").css("visibility", "hidden");
                        }, 200);

                        var $form = $(this).closest("form");
                        $form.find("input[type=submit]").click();
                    } else {
                        if (query.length > 0) {
                            $(".bloomable-search__popup").css("visibility", "visible");
                            $.get(dashboardUrl + "/public/search-locations?q=" + query, function (data) {
                                if (data.location) {
                                    $(".bloomable-search__popup").css("visibility", "hidden");
                                } else {
                                    $(".bloomable-search__popup").css("visibility", "visible");
                                }
                                $collectionSearchResults.empty();
                                for (let i = 0; i < data.collections.length && i < 5; i++) {
                                    if (data.collections[i].handle !== "upsells") {
                                        let link = $("<a>")
                                            .attr("href", "/collections/" + data.collections[i].handle)
                                            .html(data.collections[i].name);

                                        $("<li>").append(link).appendTo($collectionSearchResults);
                                    }
                                }

                                for (let i = 0; i < data.locations.length && i < 5; i++) {
                                    let link = $("<a>")
                                        .attr("href", "/collections/" + data.locations[i].handle)
                                        .html(data.locations[i].name);

                                    $("<li>").append(link).appendTo($collectionSearchResults);
                                }

                                $productSearchResults.empty();
                                for (let i = 0; i < data.products.length && i < 5; i++) {
                                    console.log(data.products[i]);
                                    let image = $("<img>").attr("height", "6px").attr("src", data.products[i].image);

                                    let productTitle = $("<div>").html(data.products[i].name);

                                    let link = $("<a>").attr("href", "/products/" + data.products[i].handle);

                                    link.append(image);
                                    link.append(productTitle);

                                    $("<li>").append(link).appendTo($productSearchResults);
                                }
                            });
                        }
                    }
                }),
            );

            $(".bloomable-search__container").css("display", "flex");
            return this;
        };
    })($);

    $(function () {
        $(".bloomable-search__input").search();
        $(".main-search__collection-results").searchReults();
    });
    // @ts-ignore
})(jQuery);
